( function () {
	'use strict';

	/*
	 * Sort Indicator Directive
	 *
	 * Usage:
	 *     <sort-indicator data-order="order" data-type="number"></sort-indicator>
	 *     <sort-indicator data-order="order" data-type="alphabet"></sort-indicator>
	 */
	function SortIndicator () {
		var directiveData = {
			'restrict'    : 'E',
			'templateUrl' : '/templates/observations/observations-list/sort-indicator.html',
			'scope'       : {
				'order'    : '=',
				'sortType' : '='
			}
		};

		return directiveData;
	}

	angular
		.module( 'app.observations' )
		.directive( 'sortIndicator', SortIndicator );

	SortIndicator.$inject = [ '$q', 'coreservice', 'logger' ];
} )();
